import DocumentPicker from 'react-native-document-picker'
import RNFS from 'react-native-fs'
import { launchCamera, launchImageLibrary } from 'react-native-image-picker'
import { PermissionsAndroid } from 'react-native'
import { Alert } from './alerts'
import {
  getLocalizedText,
  fileTooLargeMessages,
  closeMessages,
  takePhotoMessages,
  chooseFromLibraryMessages,
  youCanChooseOneImageMessages,
} from './languageLocale'
import { dataLimit } from './numbers'

export const ImagePicker = {
  showImagePicker: (options, response) => {
    Alert.alert(
      getLocalizedText(youCanChooseOneImageMessages).body,
      null,
      [
        {
          text: getLocalizedText(takePhotoMessages).body,
          onPress: () => requestCameraPermission(options, response),
        },
        {
          text: getLocalizedText(chooseFromLibraryMessages).body,
          onPress: () => launchImageLibrary(options, response),
        },
      ],
      {
        cancelable: true,
      }
    )
  },
}

export const FilePicker = {
  showFilePicker: async callback => {
    try {
      const pickedRaw =
        typeof DocumentPicker.pickSingle === 'function'
          ? await DocumentPicker.pickSingle()
          : await DocumentPicker.pick()

      const result = Array.isArray(pickedRaw) ? pickedRaw[0] : pickedRaw

      if (!result || !result.uri) {
        return
      }

      const size = typeof result.size === 'number' ? result.size : undefined
      if (typeof size === 'number' && size >= dataLimit) {
        const { title, body } = getLocalizedText(fileTooLargeMessages)
        const { body: closeMsg } = getLocalizedText(closeMessages)
        Alert.alert(
          title,
          body,
          [
            {
              text: closeMsg,
              style: 'cancel',
            },
          ],
          { cancelable: true }
        )
      } else {
        const { uri } = result
        const uriToRead =
          typeof uri === 'string' && uri.indexOf('content://') === 0
            ? uri
            : decodeURI(uri)
        const data = await RNFS.readFile(uriToRead, 'base64')

        callback({
          data,
          filename: result.name || result.fileName,
        })
      }
    } catch (err) {
      console.log('ERROR:', err)
    }
  },
}

const requestCameraPermission = async (options, response) => {
  try {
    const granted = await PermissionsAndroid.request(
      PermissionsAndroid.PERMISSIONS.CAMERA
    )
    if (granted === PermissionsAndroid.RESULTS.GRANTED) {
      launchCamera(options, response)
    } else {
      console.log('Camera permission denied')
    }
  } catch (err) {
    console.error(err)
  }
}
